/**
 * 연령인증, 5만원이상 최초 충전 등 로그인 이후 별도의 약관 및 인증이 필요할 때 사용하는 타입입니다.
 */
export enum SelfCertRequestType {
  Unknown = 'unknown',
  UnderAge14 = 'under_age_14',
  Age15 = 'age_15',
  Age19 = 'age_19',
  OverCharging = 'over_charging',
  AutoCharging = 'auto_charging',
  TvPoint = 'tv_point',
  TvPointTerms = 'tv_point_terms',
  Parent = 'legal_agent',
  CreditRefund = 'credit_refund',
  Normal = 'normal',
}
